import Api from "@/lib/axios";

const AnalyzerService = {
  async getDifferenceInDestCountriesConfig() {
    const response = await Api.get("/api/autopricing/analyzer/difference-in-dest-countries-config", {
      tenant: true
    })

    const list = response?.data;

    return {
      list,
    };
  },

  async getSummaries() {
    const response = await Api.get("/api/autopricing/analyzer/summaries", {
      tenant: false
    });

    return response?.data;
  },

  async getMissingCorridors() {
    const response = await Api.get("/api/autopricing/analyzer/missing-corridors", {
      tenant: false
    });

    return response?.data;
  },

  async getDeviatedEndRateFromMarket() {
    const response = await Api.get("/api/autopricing/analyzer/deviated-end-rate-from-market", {
      tenant: false
    });

    return response?.data;
  },

  async getExistingManualRates() {
    const response = await Api.get("/api/autopricing/analyzer/existing-manual-rates", {
      tenant: false
    });

    return response?.data;
  }
}

export default AnalyzerService;